export default class RootStore {
  init() {}
}
